import { useMemo } from 'react';

import { CircularProgress } from '@occc/ui-design-system';
import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';

import {
  getStoredValueUpdateBreadcrumbLinks,
  STORED_VALUE_UPDATE_PAGE_TITLE,
} from './stored-value-update-page.utils';

export const StoredValueUpdateLoading = () => {
  const links = useMemo(() => getStoredValueUpdateBreadcrumbLinks(''), []);
  useAppLayoutContextConsumer(links);

  return (
    <Page
      browserTabTitle={STORED_VALUE_UPDATE_PAGE_TITLE}
      pageHeaderProps={{ title: STORED_VALUE_UPDATE_PAGE_TITLE }}
      containerProps={{ variant: 'md' }}
    >
      <CircularProgress />
    </Page>
  );
};
